module.exports = __webpack_public_path__ + "static/main-500-d0c47efefc028b338f91d97e0f74b33c.png";